import React, { useRef } from "react";
import { func, bool, string } from "prop-types";
import { Trans, useTranslation } from "@lib/i18n";

import Modal from "@components/shared/Modal";
import ButtonGroup from "@components/shared/ButtonGroup";
import Typography from "@components/shared/Typography";
import RequestButton from "@components/shared/RequestButton";

const ConfirmCEESubsidyModal = ({
  isOpen,
  onRequestSuccess,
  ceeSubsidyType,
}) => {
  const { t } = useTranslation();

  const modalFirstElement = useRef(null);
  const modalLastElement = useRef(null);

  const onConfirmClick = async () => {
    await onRequestSuccess();

    return new Promise(() => null);
  };

  return (
    <Modal
      disableBackdropClick
      isOpen={isOpen}
      firstElement={modalFirstElement}
      lastElement={modalLastElement}
      ariaLabel={t(`basket.ceeSubsidy.${ceeSubsidyType}.modal.title`)}
    >
      <div className="flex flex-col items-center">
        <Typography className="text-2xl font-semibold mb-4">
          {t(`basket.ceeSubsidy.${ceeSubsidyType}.modal.title`)}
        </Typography>
        <Typography>
          <Trans i18nKey={`basket.ceeSubsidy.${ceeSubsidyType}.modal.text`} />
        </Typography>
        <ButtonGroup className="justify-center">
          <RequestButton
            ref={modalFirstElement}
            data-id="basket-ceeSubsidyModal-confirm"
            triggerRequestCallback={onConfirmClick}
          >
            {t(`basket.ceeSubsidy.${ceeSubsidyType}.modal.confirm`)}
          </RequestButton>
        </ButtonGroup>
      </div>
    </Modal>
  );
};

ConfirmCEESubsidyModal.propTypes = {
  onRequestSuccess: func.isRequired,
  isOpen: bool.isRequired,
  ceeSubsidyType: string.isRequired,
};

export default ConfirmCEESubsidyModal;
